/**
 * @category    ScandiPWA
 * @package     ScandiPWA_CjPublicis
 * @author      Ricards Nedosvitnijs <info@scandiweb.com>
 * @copyright   Copyright (c) 2022 Scandiweb, Ltd (https://scandiweb.com)
 */

export { default } from './CookieScript.container';
